import { render, staticRenderFns } from "./OfficialSecret.vue?vue&type=template&id=3a20d2d1&scoped=true&"
import script from "./OfficialSecret.vue?vue&type=script&lang=js&"
export * from "./OfficialSecret.vue?vue&type=script&lang=js&"
import style0 from "./OfficialSecret.vue?vue&type=style&index=0&id=3a20d2d1&prod&lang=less&scoped=true&"
import style1 from "./OfficialSecret.vue?vue&type=style&index=1&id=3a20d2d1&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a20d2d1",
  null
  
)

export default component.exports